module.exports = __webpack_public_path__ + "static/media/pig.19365696.png";